import { Invoice } from '../generated/nest-graphql'

export const serviceUrgencyOptions = [
  'I’m looking to get my repairs done ASAP',
  'I am going to get my repairs done but not sure when',
  'I am not sure if I need repairs',
  'I am just looking for a price',
]

export const contactMethodOptions = ['Text (SMS)', 'Call']

export const hearAboutUsOptions = [
  'Referred By Friend',
  'NuBrakes Van',
  'Google Maps',
  'Google Search',
  'Radio',
  'TV',
  'YouTube',
  'Yelp',
  'Facebook / Instagram',
  'Nextdoor',
  'Pandora',
  'Spotify',
  'Bing',
  'Billboard',
  'Other',
]

export const zipRegex = /^\d{5}$/
export const phoneRegex = /^[0-9]{10}$/

// NUB-453: email made optional to test its effect on conversion; set true to require it again.
export const LEAD_FORM_EMAIL_REQUIRED = false

export const axleOptions = [
  { label: 'Front', value: 'front' },
  { label: 'Rear', value: 'rear' },
  { label: 'Both', value: 'both' },
  { label: `I don't know`, value: 'unknown' },
]
export const symptomOptions = [
  { label: 'I need new pads / shoes', value: 'newPadsShoes' },
  { label: 'I need new rotors / drums', value: 'newRotorsDrums' },
  { label: 'Squeaking / squealing', value: 'squeakingSquealing' },
  { label: 'Grinding / scraping', value: 'grindingScraping' },
  { label: 'Vibrating / shaking / pulsing', value: 'vibratingShakingPulsing' },
  { label: 'Pedal pressure issue', value: 'pedalPressureIssue' },
  { label: 'Something else', value: 'somethingElse' },
]
export type SymptomOption =
  | 'newPadsShoes'
  | 'newRotorsDrums'
  | 'squeakingSquealing'
  | 'grindingScraping'
  | 'vibratingShakingPulsing'
  | 'pedalPressureIssue'
  | 'somethingElse'

export const standaloneOptions = [
  // { label: 'Synthetic Oil Change', value: 'syntheticOilChange', helperText: 'Change every 3 mo / 5,000 miles' },
  // {
  //   label: 'General Maintenance',
  //   value: 'generalMaintenance',
  //   helperText: 'Oil Change, Tire Rotation, Filters & Wipers',
  // },
  { label: 'Battery Replacement', value: 'batteryReplacement', helperText: 'Test and replace as needed' },
]

export const addOnOptions = [
  { label: 'Tire Rotation', value: 'tireRotation', helperText: 'Rotate every 5,000-8,000 miles' },
  { label: 'Engine Air Filter', value: 'engineAirFilter', helperText: 'Inspect yearly & replace as needed' },
  { label: 'Cabin Air Filter', value: 'cabinAirFilter', helperText: 'Replace yearly or every 12,000 miles' },
  { label: 'Front Windshield Wipers', value: 'frontWipers', helperText: 'Replace every 6-12 months' },
  { label: 'Rear Windshield Wipers', value: 'rearWipers', helperText: 'Replace every 6-12 months' },
  { label: 'Wiper Fluid Top Off', value: 'wiperFluid' },
  { label: 'Tire Pressure Check & Fill', value: 'tirePressure' },
]

export const EJI_DISCOUNT_TYPE_PERCENT = 'Percent'
export const EJI_DISCOUNT_TYPE_FLAT = 'Flat'

export const floridaMarkets = ['Tampa', 'Miami', 'Jacksonville', 'Orlando']

export const isFlorida = (invoice: Invoice) =>
  floridaMarkets.includes(invoice?.market) || invoice?.job?.serviceLocationAddress?.state === 'FL'
